export * from "./app-mode.const";

export const ItemMode = {
  SPRINT: 'sprint',
  RELAY: 'relay',
  BOTH: 'both'
};

export const CartType = {
  SPRINT: 'sprint',
  RELAY: 'relay'
};